import demo_webm from './videos/demo.webm';
import demo_mp4 from './videos/demo.mp4';
import demo_poster from './pictures/demo_poster.png';
import { replayTutorial } from './Tutorial.js';

function Help({setShowHelp}) {

  // Board is listening - close out of the way so the lesson board is visible
  const showTutorial = () => {
    setShowHelp(false);
    replayTutorial();
  };

  return <div className="hud-overlay" onClick={() => setShowHelp(false)}>
    <div className="help hud" onClick={(e) => e.stopPropagation()}>
        <button className="hud-close" onClick={() => setShowHelp(false)} aria-label="Close">&#x2715;</button>
        <h2>How to Play</h2>
        <p>Drag a rectangle to select a group that sums to 10. Matched numbers disappear. Clear all possible matches to win.</p>
        <video
        width="200"
        height="150"
        autoPlay
        muted
        loop
        playsInline
        ref={(el) => { if (el) el.playbackRate = 0.9; }}
        poster={demo_poster}
        >
        <source src={demo_webm} type="video/webm" />
        <source src={demo_mp4} type="video/mp4" />
        </video>
        <p><b>Note:</b> All boards are clearable!</p>
        <button className="help-tutorial-btn" onClick={showTutorial}>
          Walk me through it
        </button>
    </div>
  </div>
}

export default Help;
